interface Props {
    html: string
    title: string
    height?: number
}

/** Imported email CSS and active content must never execute in the Seller document. */
export default function HtmlTemplatePreview({ html, title, height }: Props) {
    return <iframe
        title={title}
        style={height ? { height } : undefined}
        sandbox=""
        referrerPolicy="no-referrer"
        className="w-full min-h-100 border-0 bg-white"
        srcDoc={`<meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src https: data:; style-src 'unsafe-inline'; base-uri 'none'; form-action 'none'">${html}`}
    />
}
